import React, { useState } from "react";

import { TypeFiesta, TypeInsignia } from "@at/design-system-foundation";
import { IconInformation } from "@at/design-system-icons";
import { Modal, ModalVariant } from "@at/design-system-patterns";

import { getChannelSingular } from "@at/formatter-utils";
import { Channel } from "@at/sauron-platform-core";

import { useChannel } from "../../../../utils/hooks/use-channel";
import { useTracking } from "../../../../utils/tracking/use-tracking";
import * as Styled from "../charging.styles";

export const WhatDoesFullChargeMean = () => {
  const [visible, setVisible] = useState(false);

  const channel = useChannel();
  const { trackModalEvent } = useTracking();
  const channelCopy =
    channel === Channel.cars ? getChannelSingular(channel) : "vehicle";

  return (
    <>
      <Styled.InfoButtonStyled
        className="is-inline-paragraph"
        onClick={() => setVisible(true)}
        aria-label="What does fastest charging speed mean?"
      >
        <IconInformation
          additionalClass="how-long-to-charge"
          title={""}
          customSize={{ width: 18, height: 18 }}
        />
      </Styled.InfoButtonStyled>

      <Modal
        isShowing={visible}
        hasBackLink={false}
        closeText="Back"
        variation={ModalVariant.SLIDE}
        hideFn={() => setVisible(false)}
        overlayName="fastest-charging"
        trackingCallback={({ modalAction }) => {
          trackModalEvent({ trackingLabel: "fastest-charging", modalAction });
        }}
      >
        <Styled.ModalBodyStyled>
          <TypeInsignia as="h2" weight="400">
            What does fastest charging speed mean?
          </TypeInsignia>

          <TypeFiesta as="p">
            The time shown is the fastest full charge time for this vehicle,
            based on charging at the fastest speed the vehicle can take.
          </TypeFiesta>

          <TypeFiesta as="p">
            The full charge time is based on charging the battery to 80%. This
            is because the speed of charge will slow down once the {channelCopy}{" "}
            battery reaches 80%, which helps protect and optimise the battery
            life.
          </TypeFiesta>

          <TypeFiesta as="p">
            Most people stop charging their vehicles once the battery reaches
            80% charge, but you can still charge your vehicle to 100% if you
            want to.
          </TypeFiesta>
        </Styled.ModalBodyStyled>
      </Modal>
    </>
  );
};
